import React, { useState, useEffect } from 'react';
import { Pool, Block } from '../types';
import { apiService, formatters } from '../services/api';

const BlocksPage: React.FC = () => {
  const [pools, setPools] = useState<Pool[]>([]);
  const [blocks, setBlocks] = useState<Block[]>([]);
  const [selectedPool, setSelectedPool] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    loadBlocks();
  }, [selectedPool]);

  const loadData = async () => {
    try {
      const [poolData, blockData] = await Promise.all([
        apiService.getPools(),
        apiService.getAllBlocks()
      ]);
      setPools(poolData);
      setBlocks(blockData);
    } catch (error) {
      console.error('Error loading data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadBlocks = async () => {
    try {
      if (selectedPool) {
        const blockData = await apiService.getPoolBlocks(selectedPool);
        setBlocks(blockData);
      } else {
        const blockData = await apiService.getAllBlocks();
        setBlocks(blockData);
      }
    } catch (error) {
      console.error('Error loading blocks:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <p>Loading blocks...</p>
      </div>
    );
  }

  return (
    <div className="blocks-page">
      <h2>Recent Blocks</h2>
      <div className="blocks-controls">
        <select 
          value={selectedPool} 
          onChange={(e) => setSelectedPool(e.target.value)}
          className="form-select"
        >
          <option value="">All Pools</option>
          {pools.map(pool => (
            <option key={pool.id} value={pool.id}>
              {pool.coin} ({pool.algorithm})
            </option>
          ))}
        </select>
      </div>
      
      <div className="blocks-table-container">
        <table className="blocks-table">
          <thead>
            <tr>
              <th>Pool</th>
              <th>Height</th>
              <th>Reward</th>
              <th>Miner</th>
              <th>Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {blocks.map((block, index) => (
              <tr key={`${block.hash}-${index}`}>
                <td>{block.pool}</td>
                <td>{block.height}</td>
                <td>{formatters.balance(block.reward, 4)}</td>
                <td>{block.miner.slice(0, 12)}...{block.miner.slice(-8)}</td>
                <td>{formatters.timeAgo(block.timestamp)}</td>
                <td>
                  <span className={`status-${block.status}`}>
                    {block.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BlocksPage;